import { Link } from "react-router-dom";
import { UserSocialData } from "../../../../Data/Applications/Users/Users";
import { LI, UL } from "../../../../AbstractElements";

const SocialMediaIcons = () => {
  return (
    <UL className="card-social simple-list flex-row">
      {UserSocialData.map((data, index) => (
        <LI key={index}>
          <Link to={data.link} target="_blank">
            <i className={`${data.icon} me-0`}></i>
          </Link>
        </LI>
      ))}
    </UL>
  );
};

export default SocialMediaIcons;